import { APP_INITIALIZER, enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { apiUrlInterceptor } from './app/interceptors/api-url.interceptor';
import { indicatorInterceptor, responseInterceptor } from 'library-explorer';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import { initializeAppFactory } from './app/factories/initialize.factory';
import { AuthService } from './app/services/auth.service';
import { InterResponseHandlerInterceptor } from './app/interceptors/internal-response-handler.interceptor';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes),
    provideHttpClient(
      // registering interceptors
      withXsrfConfiguration({
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN',
      }),
      withInterceptors([apiUrlInterceptor, authInterceptor, indicatorInterceptor, responseInterceptor, InterResponseHandlerInterceptor])
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      deps: [AuthService],
      multi: true
    }
  ],
});
